<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{sidebarHeader}}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6" :settings="settings">
      <div class="pl-6 pr-6 pb-6">
        <div>
          <label>Name</label>
          <vs-input autocomplete="off" v-validate="'required'" name="Name" v-model="formData.name" class="w-full" />
          <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
        </div>

        <!-- DESCRIPTION -->
        <div class="pt-4 pb-6">
          <label>Description</label>
          <vs-textarea name="Description" v-model="formData.description" class="w-full" />
        </div>

        <!-- IMG -->
        <div class="flex flex-wrap items-center justify-center">
          <img src="https://forty5degreesstorage.blob.core.windows.net/assets/ispring-quizmaker(small).png" v-show="formData.uploadedFileName || this.formData.url" @click="showUpload" width="50%" class="cursor-pointer">
        </div>
        <!-- <vs-upload @on-success="successUpload" automatic :action="uploadLocation" text="Upload Audio" class="img-upload" ref="fileUpload" accept="audio/wav,audio/mp3" v-show="!formData.uploadedFileName" /> -->
        <div class="flex vs-con-loading__container flex-wrap items-center justify-center pb-4">
          <v-uploader @done="successUpload" v-show="!(formData.uploadedFileName || this.formData.url)" ref="fileUpload" button-text="Upload Quiz Folder" file-type-exts="zip" language="en" file-size-limit="100MB" :preview="false" ></v-uploader>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center pb-4 pt-1" slot="footer">
      <vs-button class="mr-4 vs-con-loading__container cursor-pointer" color="success" @click="updateApproach" :disabled="isDisabled" ref="addupdateButton">{{buttoncaption}}</vs-button>
      <vs-button color="danger" class="mr-4 vs-con-loading__container cursor-pointer" v-show="formData.id" @click="deleteQuiz" ref="deleteButton">Delete</vs-button>
      <vs-button type="border" class="ml-4 cursor-pointer" color="warning" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    selectedQuiz: {
      type: Object,
      required: false
    },
    buttoncaption: {
      type: String,
      required: false
    },
    sidebarHeader: {
      type: String,
      required: false
    },
  },

  data() {
    return {
      backgroundLoading:'#fff',
      isFileUploaded: false,
      hasUrl: false,
      formData: {
        id: 0,
        name: "",
        description: "",
        uploadedFileName: "",
        url: "",
        isUsed: false
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      isLoading: false,
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          this.initValues();
        }
      }
    },
    uploadLocation: {
      get() {
        return this.$buildUrl("tempupload");
      }
    },
    isDisabled: function(){
      return !(this.formData.uploadedFileName || this.formData.url);
    }
  },
  watch: {
    isSidebarActive: function(val) {
      if(val){
        if(this.selectedQuiz.id){
          this.formData.id = this.selectedQuiz.id;
          this.formData.name = this.selectedQuiz.name;
          this.formData.description = this.selectedQuiz.description;
          this.formData.url = this.selectedQuiz.url;
          this.formData.isUsed = this.selectedQuiz.isUsed;
        } else {
          this.initValues();
        }
      }
    }
  },
  methods: {
    initValues() {
      this.formData.id = 0;
      this.formData.name = "";
      this.formData.description = "";
      this.formData.uploadedFileName = "";
      this.formData.url = "";
      this.formData.isUsed = false;
      this.isLoading = false;
      this.errors.clear();
    },
    successUpload(data) {
      this.formData.uploadedFileName = data[0].url;
      this.$vs.loading.close(this.$refs.fileUpload.$el);
		  this.isLoading = false;
    },
    saveData(){
     this.$emit('saveData');
     this.$vs.loading.close(this.$refs.addupdateButton.$el);
    },
    addEditQuiz() {
      var self = this;
      if (!(self.formData.uploadedFileName || self.formData.url)) {
        self.$vs.notify({
          title:'Attention',
          color: "danger",
          text: "Please upload a file.",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-upload'
        });
        return;
      }

      self.$validator.validateAll().then(result => {
        if (result) {
          self.showLoadingOnButton();
          if(self.formData.isUsed)
            self.showLoadingOnList();

          var onSuccess = response => {
            this.saveData();
            self.$vs.notify({
              title:'Information',
              color: "success",
              text: "Quiz Saved",
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-save'
            });
          };
          var onFinally = function (){
            self.$vs.loading.close(self.$refs.addupdateButton.$el);
            self.$vs.loading.close(self.$parent.$el);
          };

          self.$ajaxPost(self, "ISpringQuiz", self.formData, onSuccess, onFinally);
        } else {
          self.$vs.notify({
            title:'Attention',
            color: "warning",
            text: self.$validator.errors.items[0].msg,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-info'
          });
        }
      });
    },
    showUpload() {
      this.formData.uploadedFileName = null;
      this.formData.url = null;
    },
    deleteQuiz() {
      var self = this;
      self.showLoadingOnDeleteButton();

      var onSuccess = response => {
        self.saveData();
        self.initValues();
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Quiz Deleted",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-trash'
        });
      };
     
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.deleteButton.$el);
      };

      self.$ajaxDelete(self, "ISpringQuiz/" + self.formData.id, onSuccess, onFinally);
    },
    showLoadingOnButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.addupdateButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnDeleteButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.deleteButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnList(){
      var self = this;
      self.$vs.loading({
        type: "corners",
        container: self.$parent.$el,
        scale: 1
      });
    },
    showLoadingOnUploader(){
      var self = this;
      self.isLoading = true;
      self.$vs.loading({
        type: "material",
        container: self.$refs.fileUpload.$el,
        scale: 0.45
      });
    },
    updateApproach() {
      if(this.formData.isUsed && this.formData.id)
        this.openConfirm();
      else
        this.addEditQuiz();
    },
    openConfirm() {
      this.$emit("closeSidebar");
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: `Attention`,
        text: 'The selected iSpring Quiz is being used in one or more quiz task(s).\n\nAre you sure you want to update it?',
        accept: this.addEditQuiz,
        acceptText: "Yes, update",
        cancelText: "No, cancel"
      })
    },
  },
  mounted() {
    var self = this;
    self.$refs.fileUpload.$el.addEventListener("click", function(){
      if(!self.isLoading)
        self.showLoadingOnUploader();
      else{
        self.isLoading = false;
        self.$vs.loading.close(self.$refs.fileUpload.$el);
      }
    });
  },
  components: {
    VuePerfectScrollbar
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}

</style>
